var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.close,
          expression: "close"
        }
      ],
      staticClass: "cart__search__input-container"
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.searchInput,
            expression: "searchInput"
          }
        ],
        staticClass: "cart__search__input cart__search__input--with-icon",
        attrs: {
          id: "client-search",
          type: "search",
          autocomplete: "new-password",
          placeholder: "Hae Y-tunnuksella tai asiakasnumerolla"
        },
        domProps: { value: _vm.searchInput },
        on: {
          keyup: _vm.handleKeyUp,
          keydown: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            $event.preventDefault()
            return _vm.search()
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.searchInput = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _vm.results.length > 0 && _vm.isOpen
        ? _c(
            "ul",
            { staticClass: "cart__search__results" },
            _vm._l(_vm.results, function(result) {
              return _c(
                "li",
                {
                  key: result.billing.customer_code,
                  staticClass: "cart__search__result",
                  attrs: { tabindex: "0" },
                  on: {
                    click: function($event) {
                      return _vm.select(result)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "cart__search__result-main" }, [
                    _vm._v(_vm._s(result.billing.company))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "cart__search__result-detail" }, [
                    _vm._v(
                      " " +
                        _vm._s(result.billing.company_id) +
                        " (" +
                        _vm._s(result.billing.customer_code) +
                        ")"
                    )
                  ])
                ]
              )
            }),
            0
          )
        : _vm.isOpen && !_vm.loading
        ? _c("div", { staticClass: "cart__search__results" }, [
            _c("div", { staticClass: "cart__search__no-results" }, [
              _vm._v("\n      Ei tuloksia\n    ")
            ])
          ])
        : _vm.isOpen && _vm.loading
        ? _c("div", { staticClass: "cart__search__results" }, [
            _c("div", { staticClass: "cart__search__no-results" }, [
              _vm._v("\n      Ladataan...\n    ")
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f9b00b78", { render: render, staticRenderFns: staticRenderFns })
  }
}